/**
 * 通用资源列表 — 表格列宽按内容量级权重比例分配。
 *
 * 仅服务于 el-table 列宽计算；不触碰控制条 / 表头 sticky 链路。
 */

/**
 * 列宽权重：四字操作按钮不换行，多出来的宽度从其余列匀来。
 * 缩略图和名称合成「资源」一列，更新时间放在操作按钮下方，都不单占一列。
 */
export const LINK_TABLE_COLUMN_WEIGHTS = {
  selection: 44,
  resource: 224,
  type: 98,
  category: 142,
  lock: 194,
  status: 98,
  action: 306,
};

const COLUMN_KEYS = Object.keys(LINK_TABLE_COLUMN_WEIGHTS);
const WEIGHT_SUM = Object.values(LINK_TABLE_COLUMN_WEIGHTS).reduce(
  (sum, value) => sum + value,
  0
);

export const LINK_TABLE_FALLBACK_WIDTH = WEIGHT_SUM;

/**
 * 按 tableZone 实测宽度与权重计算各列像素宽，末列吃掉余数。
 *
 * @param {number} containerWidth tableZone clientWidth
 * @returns {Record<string, number>}
 */
export function computeLinkTableColumnWidths(containerWidth) {
  const raw = Math.floor(Number(containerWidth) || 0);
  const width = raw > 0 ? raw : LINK_TABLE_FALLBACK_WIDTH;
  const result = {};
  let assigned = 0;

  COLUMN_KEYS.forEach((key, index) => {
    if (index === COLUMN_KEYS.length - 1) {
      result[key] = width - assigned;
      return;
    }
    const slice = Math.floor(
      (width * LINK_TABLE_COLUMN_WEIGHTS[key]) / WEIGHT_SUM
    );
    result[key] = slice;
    assigned += slice;
  });

  return result;
}
